import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "../axios-orders";
import { PurchaseOrderHoliday, PurchaseOrderHolidayInput } from "../types";
import { queryKeys } from "./queryKeys";

/**
 * The holidays that apply to the company (`GET`, MANAGE_PURCHASE_ORDER_APPROVALS + OC module):
 * its own editable ones plus its country's national ones (`national: true`, read-only).
 */
export const useOcHolidays = () =>
  useQuery<PurchaseOrderHoliday[]>({
    queryKey: [queryKeys.PURCHASE_ORDER_HOLIDAYS],
    queryFn: async () => {
      const { data } = await axios.get("/purchase-orders/settings/holidays");
      return data;
    },
  });

/**
 * `PUT` REPLACES the company-specific set (anything omitted is deleted server-side, `[]` clears
 * them all); national holidays are never sent and are untouched. A 400 means a missing or
 * duplicate date, or a label over 255 characters.
 */
export const useReplaceOcHolidays = () => {
  const queryClient = useQueryClient();
  return useMutation<
    PurchaseOrderHoliday[],
    Error,
    PurchaseOrderHolidayInput[]
  >({
    mutationFn: async (rows) => {
      const { data } = await axios.put(
        "/purchase-orders/settings/holidays",
        rows
      );
      return data;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [queryKeys.PURCHASE_ORDER_HOLIDAYS],
      }),
  });
};
